<script>
import eventDefinitions from '~/events/eventDefinitions'

export default {
  data() {
    return {
      eventCheckoutStepLoadFired: false,
    }
  },
  computed: {
    cartData() {
      return this.$store.state.cart.cartData
    },
  },
  watch: {
    cartData: {
      handler: function(newValue, oldValue) {
        if (newValue && newValue.items && !this.eventCheckoutStepLoadFired) {
          this.$eventBus.$emit(eventDefinitions.CHECKOUT.STEP_LOAD, {
            cartState: this.$store.state.cart,
          })
          this.eventCheckoutStepLoadFired = true
        }
      },
      immediate: true,
    },
  },
}
</script>
